import { combineEpics, createEpicMiddleware } from "redux-observable";
import ExchangeRate from "state/ExchangeRate";
import BalanceCfg from "state/BalanceCfg";

export const rootEpic = combineEpics(ExchangeRate.epic, BalanceCfg.epic);

export const epicMiddleWare = createEpicMiddleware();
